<form class="form-horizontal" focusInvalidInput novalidate autocomplete="off" [formGroup]="approveRejectBidForm"
    (ngSubmit)="save()">
    <div class="row">
        <div class="col-md-12 mb-3" *ngIf="approveBid">
            <app-input-number-control [formName]="approveRejectBidForm" elementId="approvedAmount"
                [control]="getControl('approvedAmount')" controlName="approvedAmount" [label]="amountLabel"
                placeholder="Approved Amount" mode="currency" currency="USD" [isCurrencyMode]="true">
            </app-input-number-control>
        </div>
        <div class="col-md-12 mb-3" *ngIf="!approveBid && !isExpire">
            <app-select-control [formName]="approveRejectBidForm" [options]="approveRejectReasons"
                elementId="loadCarrierBidRejectionReasonId" controlName="loadCarrierBidRejectionReasonId"
                [control]="getControl('loadCarrierBidRejectionReasonId')" [multipleSelection]="false" [filter]="false"
                [showClear]="false" [isPrimeNgDropdown]="true" [isServerSideFilter]="false" styleClass="w-100"
                [isShowLabel]="true" label="Reason Code">
            </app-select-control>
        </div>
        <div class="col-md-12 mb-3">
            <app-input-control [formName]="approveRejectBidForm" elementId="additionalComment"
                [control]="getControl('additionalComment')" controlName="additionalComment"
                [label]="additionalCommentsLabel" [placeholder]="additionalCommentsLabel">
            </app-input-control>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-right pb-0">
            <button class="btn btn-primary mr-2" *ngIf="approveBid && isApprove">Approve</button>
            <button type="button" class="btn btn-primary mr-2"
                *ngIf="(!isApprove && carrierBid?.bidStage !== LoadCarrierBidStage.RequestorCountered) && !isRejectClicked"
                (click)="onCounterClick()">Counter</button>
            <button class="btn btn-primary mr-2" *ngIf="!approveBid && !isExpire">Reject</button>
            <button type="button" class="btn btn-primary mr-2" *ngIf="!approveBid && isExpire"
                (click)="onDeadClick()">Dead</button>
            <button type="button" (click)="cancel()" class="btn btn-outline-primary">
                Cancel
            </button>
        </div>
    </div>
</form>